import { render } from "./TextArea.vue?vue&type=template&id=c3a0cfde&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=c3a0cfde&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3a0cfde"

export default script